module.exports = ".sitiosInteres{color:white;cursor:pointer}.sitiosInteres:hover{color:silver}\n"